import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PricingSection } from './components/PricingSection';
import { ContactForm } from './components/ContactForm';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Footer } from './components/Footer';
import { BrandBook } from './pages/BrandBook';
import { PlanoTool } from './pages/PlanoTool';
export function App() {
  const [showBrandBook, setShowBrandBook] = useState(false);
  const [showPlanoTool, setShowPlanoTool] = useState(false);
  useEffect(() => {
    const checkHash = () => {
      setShowBrandBook(window.location.hash === '#brand');
      setShowPlanoTool(window.location.hash === '#plano');
    };
    checkHash();
    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);
  if (showPlanoTool) {
    return <PlanoTool data-id="element-0" />;
  }
  if (showBrandBook) {
    return <BrandBook data-id="element-1" />;
  }
  return <div className="min-h-screen bg-white selection:bg-blue-100 selection:text-blue-900" data-id="element-2">
      <Navbar data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <ContactForm data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
      <WhatsAppButton data-id="element-12" />
    </div>;
}